import {css} from 'styled-components';

export const settingsHorizontalSpacing = 48;
export const settingsNavigationWidth = 240;

export const settingsHorizontalPaddingStyles = css`
  padding-left: ${settingsHorizontalSpacing}px;
  padding-right: ${settingsHorizontalSpacing}px;
`;

export const settingsResourceTableLineHeight = 56;
export const settingsResourceTableHeadingHeight = 40;

export function maybeApplyResourcesTableCellPaddingStyles(isFirst?: boolean) {
  if (!isFirst) {
    return css`
      padding-left: 12px;
      padding-right: 12px;
    `;
  }

  return '';
}

export function applyTableCellWidthStyles(isFirst?: boolean, isHeading?: boolean) {
  if (!isFirst) {
    return css`
      width: 140px;
    `;
  }

  return css`
    position: sticky;
    left: ${isHeading ? settingsHorizontalSpacing : 36}px;
    min-width: 330px;
    flex: 1;
  `;
}
